export const env = {...process.env, ...window['env']}


// let env = {...process.env, ...window['env']};
//
// // Load config synchronously ngay khi file được import
// const loadConfigSync = () => {
//     try {
//         const baseUrl = env.REACT_APP_BACKEND_URL;
//         if (baseUrl) {
//             // dùng XMLHttpRequest để load đồng bộ
//             const xhr = new XMLHttpRequest();
//             xhr.open('POST', `${baseUrl}/get-config`, false); // false = synchronous
//             xhr.send();
//             const remoteEnv = JSON.parse(xhr.responseText);
//
//             Object.assign(env, remoteEnv);
//         }
//     } catch (error) {
//         console.error("Could not fetch remote env", error);
//     }
// };
//
// // Load config ngay lập tức
// loadConfigSync();
//
// export { env };
